import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("k_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && !e.config?.url?.includes("/auth/")) {
      localStorage.removeItem("k_token");
      localStorage.removeItem("k_user");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(e);
  }
);

export default client;

export const getToken = () => localStorage.getItem("k_token");
export const getUser = () => {
  const u = localStorage.getItem("k_user");
  return u ? JSON.parse(u) : null;
};
export const saveAuth = (token, user) => {
  localStorage.setItem("k_token", token);
  localStorage.setItem("k_user", JSON.stringify(user));
};
export const clearAuth = () => {
  localStorage.removeItem("k_token");
  localStorage.removeItem("k_user");
};
